import { useAuth0 } from "@auth0/auth0-react";
import { DEFAULT_LOCALE, DEFAULT_PARTNER } from "@pandas/core-ui";
import { Link, useLocation, useParams } from "@tanstack/react-router";
import { useStore } from "../../store";
import UserMenu from "./UserNavbarMenu";

type AppLayoutProps = {
	children: React.ReactNode;
};

export default function AppLayout({ children }: AppLayoutProps) {
	const theming = useStore((state) => state.config?.theming);
	const { pathname } = useLocation();
	const { user, isLoading } = useAuth0();
	const { locale = DEFAULT_LOCALE, partner = DEFAULT_PARTNER } = useParams({ strict: false }) as {
		locale?: string;
		partner?: string;
	};

	const isLoginPage = pathname === "/";

	// While auth is loading on a protected page, show just the navbar
	if (!isLoginPage && isLoading) {
		return (
			<div
				style={{ backgroundColor: theming ? theming.navbarColor : "black" }}
				className="bg-black flex justify-between items-center px-8 shadow-md print:hidden"
			>
				<div className="h-12 w-56 select-none relative flex my-3">
					<img
						src={`${theming?.assets.navbarLogo ?? "/brand/pandas-logo.svg"}`}
						height={48}
						alt="logo"
					/>
				</div>
			</div>
		);
	}

	return (
		<div className="flex min-h-[100dvh] flex-col">
			<div
				style={{
					backgroundColor: theming ? theming.navbarColor : "black",
				}}
				className="bg-black flex shrink-0 sticky top-0 z-20 justify-between items-center px-8 shadow-md print:hidden"
			>
				<Link
					to={user ? "/$locale/$partner/home" : "/"}
					params={user ? { locale, partner } : {}}
				>
					<div className="h-10 max-w-80 select-none relative flex my-3">
						<img
							src={`${theming?.assets.navbarLogo ?? "/brand/pandas-logo.svg"}`}
							height={48}
							alt="logo"
						/>
					</div>
				</Link>
				<div className="flex items-center py-5">{user && <UserMenu />}</div>
			</div>
			<main className="flex flex-1 flex-col">{children}</main>
		</div>
	);
}
